<template>
  <v-card>
    <v-tabs v-model="tab" bg-color="primary">
      <v-tab value="tab1">投稿管理</v-tab>
      <v-tab value="tab2">メール配信管理</v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="tab1">
          <v-data-table
            :headers="postHeaders"
            :items="postList"
            v-model="selectedPosts"
            hide-default-footer
            dense
            show-select
          ></v-data-table>
          <v-row justify="end"
            ><v-dialog v-model="deleteDialog" persistent width="auto">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" class="mt-2 mr-2 mb-2" v-bind="props"
                  >選択投稿削除</v-btn
                >
              </template>
              <v-card>
                <v-card-text>本当に削除しますか？</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteDialog = false"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deletePosts()"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog></v-row
          >
        </v-window-item>

        <v-window-item value="tab2">
          <v-data-table
            :headers="mailHeaders"
            :items="mailList"
            v-model="selectedMails"
            hide-default-footer
            dense
            show-select
          ></v-data-table>
          <v-row justify="end"
            ><v-dialog v-model="deleteDialog2" persistent width="auto">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" class="mt-2 mr-2 mb-2" v-bind="props"
                  >選択メールアドレス削除</v-btn
                >
              </template>
              <v-card>
                <v-card-text>本当に削除しますか？</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteDialog2 = false"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteMail()"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog></v-row
          >
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
  <v-card><v-card-text> </v-card-text></v-card>
</template>

<script>
import Export from "../export";
import store from "../store";
export default {
  name: "DisplayPosts",
  props: {
    msg: String,
  },
  mounted() {
    if (this.loginState == false) {
      this.$router.push("/");
    } else {
      this.getAllPosts();
      this.getAllMailAddress();
    }
  },
  data() {
    return {
      postTitle: "",
      postText: "",
      emergency: false,
      deliverMail: false,
      deleteDialog: false,
      deleteDialog2: false,
      tab: "tab1",
      postHeaders: [
        {
          title: "日時",
          value: "datetime",
        },
        {
          title: "タイトル",
          value: "title",
        },
        {
          title: "本文",
          value: "text",
        },
      ],
      mailHeaders: [
        {
          title: "氏名",
          value: "name",
        },
        {
          title: "メールアドレス",
          value: "mail",
        },
      ],
      selectedPosts: [],
      selectedMails: [],
      mailList: [],
    };
  },
  computed: {
    posts: {
      get() {
        return store.state.posts;
      },
      set(value) {
        store.state.posts = value;
      },
    },
    loginState: {
      get() {
        return store.state.loginState;
      },
      set(value) {
        store.state.loginState = value;
      },
    },
    isLoading: {
      get() {
        return store.state.isLoading;
      },
      set(value) {
        store.state.isLoading = value;
      },
    },
    postList() {
      var list = [];
      for (var i = 0; i < this.posts.length - 1; i++) {
        var item = this.posts[i];
        item.datetime = this.timestampToTime(this.posts[i].timestamp);
        list.push(item);
      }
      return list;
    },
  },
  methods: {
    async getAllPosts() {
      var getPosts = await Export.getAllPosts();
      this.posts = getPosts.data;
      this.posts = this.posts.sort(function (a, b) {
        return a.timestamp > b.timestamp ? -1 : 1; //オブジェクトの降順ソート
      });
    },
    async getAllMailAddress() {
      var getAllMailAddress = await Export.getAllMailAddress();
      this.mailList = getAllMailAddress.data;
    },
    async deletePosts() {
      this.isLoading = true;
      for await (let id of this.selectedPosts) {
        await Export.deletePost(id);
      }
      await this.getAllPosts();
      this.deleteDialog = false;
      this.isLoading = false;
    },
    async deleteMail() {
      this.isLoading = true;
      for await (let id of this.selectedMails) {
        await Export.deleteMail(id);
      }
      await this.getAllMailAddress();
      this.deleteDialog2 = false;
      this.isLoading = false;
    },
    timestampToTime(timestamp) {
      var d = new Date(Number(timestamp));
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    makeShort(txt) {
      var st = txt.substr(0, 12);
      return st + "...";
    },
    showDetail(id) {
      this.detailPanel = true;
      this.detailIndex = id;
    },
    async post() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card-text {
  font-size: 1rem !important;
}
.v-card-subtitle {
  font-size: 0.9rem !important;
}
.itemList dt {
  font-size: 0.9rem !important;
  color: #7a7a7a;
}
.itemList dd {
  font-size: 1rem !important;
}
.sectionTitle {
  color: #44bd3f;
  text-align: center;
}
</style>
